import React, { useContext } from "react";
import TickerContext from "../../../../context/ticker";
import MyContext from "../../../../context/MyContext";
import axios from "axios";
import { pictureForLayer } from "../../../../Utils/layerImages";
import AuthContext from "../../../../context/userAuth.context";
import { LoadingContext } from "../../../../context/LoadingContext";
import ProjectContext from "../../../../context/ProjectContext";

const Photo = (props) => {
  const context = useContext(LoadingContext);
  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    setChangeCount,
    calculateTimeByWidth,
    calculateWidthByDuration,
    Tl_TotalTime,
    EditorZoom,
    seteditableObject,
    ImageData,
    setImageData,
  } = useContext(MyContext);

  const { authenticationData } = useContext(AuthContext);

  const { Goto, setGoto, TickerPosition } = useContext(TickerContext);

  const { slides, setslides } = useContext(ProjectContext);

  var pageX = 0;
  var pageY = 0;
  var dragStartLeft = 0;
  var dragStartTop = 0;

  var blankCanvas = document.createElement("canvas");

  const dragStart = (e) => {
    let previewDragger = document.getElementsByClassName("previewDragger")[0];
    previewDragger.style.display = "";
    previewDragger.src = e.target.previousSibling.src;
    previewDragger.setAttribute("picurl", e.target.attributes.picurl.value);
    let dragStartLeftPercentage = e.nativeEvent.offsetX / e.target.offsetWidth;
    let dragStartTopPercentage = e.nativeEvent.offsetY / e.target.offsetHeight;
    dragStartLeft = dragStartLeftPercentage * previewDragger.offsetWidth;
    dragStartTop = dragStartTopPercentage * previewDragger.offsetHeight;
    e.nativeEvent.dataTransfer.setDragImage(blankCanvas, 0, 0);
  };

  const drag = (e) => {
    let previewDragger = document.getElementsByClassName("previewDragger")[0];
    let previewDraggerWidth = previewDragger.offsetWidth;
    let previewDraggerHeight = previewDragger.offsetHeight;
    e.nativeEvent.dataTransfer.setDragImage(blankCanvas, 0, 0);
  };

  document.ondragover = function (e) {
    let previewDragger = document.getElementsByClassName("previewDragger")[0];
    pageX = e.clientX || e.pageX;
    pageY = e.clientY || e.pageY;
    previewDragger.style.left = pageX - previewDragger.offsetWidth / 2 + "px";
    previewDragger.style.top = pageY - previewDragger.offsetHeight / 1.5 + "px";
  };

  const dragEnd = (e) => {
    let previewDragger = document.getElementsByClassName("previewDragger")[0];
    previewDragger.style.display = "none";
  };

  var resizedataURL = function (base64, wantedWidth, wantedHeight) {
    return new Promise(function (resolve, reject) {
      // We create an image to receive the Data URI
      var img = document.createElement("img");

      // When the event "onload" is triggered we can resize the image.
      img.onload = function () {
        // We create a canvas and get its context.
        //var coeff = percentage/100;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        // We set the dimensions at the wanted size.
        //canvas.width = wantedWidth;
        //canvas.height = wantedHeight;

        var ratio = canvas.width / canvas.height;
        canvas.height = wantedWidth / ratio;
        canvas.width = wantedWidth;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        var dataURI = canvas.toDataURL("image/jpeg", 0.85);
        resolve(dataURI);
        /////////////////////////////////////////
        // Use and treat your Data URI here !! //
        /////////////////////////////////////////
      };

      // We put the Data URI in the image's src attribute
      img.src = base64;
    });
  };

  const addImage = (e, url) => {
    //context.setIsLoading(true);
    let ratio = e.target.clientHeight / e.target.clientWidth;

    var stack = [...UndoLayer];
    var PrevArray;

    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = [];
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    // Replace the picture of the selected layer: keep a link (see Utils/layerImages.js).
    // (Before: an embedded copy, set after setLayersData had already run.)
    const applyPicture = (src) => {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === Goto.key) {
          array[i].ImageSrc = src;
          array[i].height = array[i].width * ratio;
        }
      }
      setLayersData(array);
      setChangeCount(ChangeCount + 1);
      setGoto({
        menu: null,
        innerMenu: null,
        key: null,
      });
    };
    pictureForLayer(authenticationData.ApiBaseURL, url, ImageURLToBase64)
      .then(applyPicture)
      .catch(function () {
        applyPicture(url);
      });

    // context.setIsLoading(false);
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const ImageClick = (IUrl, ITop, ILeft, IWidth, Iheight, ImageBlob, event) => {
    //context.setIsLoading(true);
    var stack = [...UndoLayer];
    var PrevArray;

    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = [];
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var typelength = 1;
    var checkKey = 0;

    for (var i = 0; i < LayersData.length; i++) {
      LayersData[i].toolbar = false;
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      if (LayersData[i].type === "image") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    // let TickPos;
    // let trans = document.getElementById('tickerHead').style.transform;
    // if (trans != "") {
    //   trans = trans.split('(')
    //   trans = trans[1].split(',')
    //   trans = trans[0].split('px')
    //   trans = eval(trans[0]);
    //   TickPos = trans
    // }

    let currentTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);

    let newEntryLayerData = {
      AnimationId: makeid(6),
      Added: true,
      key: checkKey + 1,
      type: "image",
      bgColor: "#554bf5",
      Name: `image-${typelength}`,
      canvas: null,
      video: null,
      TimelineZoom: timelineZoomVal,
      userFile: "xyz",
      layerIndex: topIndex,
      index: null,
      duration: totalTime,
      startTime: currentTime,
      EditorZoom: EditorZoom,
      originalX: null,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      volume: null,
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      InClass: "",
      OutClass: "",
      typeIcon: "vrpano",
      STdiff: null,
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      angle: 0,
      ImageSrc: IUrl,
      crop: "false",
      lock: false,
      x: ILeft,
      y: ITop,
      flip: "scaleX(1)",
      width: IWidth,
      height: Iheight,
      toolbar: true,
      FurtherSetting: false,
      opacity: 1,
      originalOpacity: 1,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      ImageBlob: ImageBlob,
      startPositionOnTimeline: TickerPosition,
      player: false,
      rotateAngle: 0,
      InMultiDrag: false,
      showDiv: true,
    };

    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    setLayersData(LayersData.concat(newEntryLayerData));
    seteditableObject({
      showPanel: true,
      editableItem: newEntryLayerData,
    });

    setChangeCount(ChangeCount + 1);
    context.setIsLoading(false);
  };

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  const ImageConverter = (e) => {
    context.setIsLoading(true);
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let _widthPercentage = 300 / CanvasWidth;
    let _heightPercentage =
      parseInt(300 * (e.target.offsetHeight / 163)) / canvasHeight;
    let _width = (CanvasWidth * _widthPercentage) / 2;
    let _height = (canvasHeight * _heightPercentage) / 2;

    //var height = parseInt(300 * (e.target.offsetHeight / 163))
    var top = getRandomArbitrary(0, canvasHeight - _height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);

    if (props.picurl.includes(".svg")) {
      SvgContent(props.relativePath)
        .then(function (baseStr) {
          ShapeClick(baseStr, top, left, _width, _height, null, e);
        })
        .catch(function () {
          ImageClick(props.picurl, top, left, _width, _height, null, e);
        });
    } else {
      // The layer keeps a link to the picture (Utils/layerImages.js); outside pictures are
      // copied to our server first. Before, the whole picture was stored in the project.
      pictureForLayer(authenticationData.ApiBaseURL, props.picurl, ImageURLToBase64)
        .then(function (src) {
          ImageClick(src, top, left, _width, _height, null, e);
        })
        .catch(function () {
          ImageClick(props.picurl, top, left, _width, _height, null, e);
        });
    }
  };

  const ShapeClick = (IUrl, ITop, ILeft, IWidth, Iheight, ImageBlob, event) => {
    context.setIsLoading(true);
    var stack = [...UndoLayer];
    var PrevArray;

    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = [];
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var typelength = 1;
    var checkKey = 0;

    for (var i = 0; i < LayersData.length; i++) {
      LayersData[i].toolbar = false;
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      if (LayersData[i].type === "image") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    let currentTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);

    let newEntryLayerData = {
      Added: true,
      key: checkKey + 1,
      type: "basicShape",
      bgColor: "#554bf5",
      Name: `shape-${typelength}`,
      TimelineZoom: timelineZoomVal,
      layerIndex: topIndex,
      duration: totalTime,
      startTime: currentTime,
      originalX: null,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      volume: null,
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      InClass: "",
      OutClass: "",
      typeIcon: "vrpano",
      STdiff: null,
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      angle: 0,
      svgContent: IUrl,
      crop: "false",
      lock: false,
      x: ILeft,
      y: ITop,
      flip: "scaleX(1)",
      width: IWidth,
      height: Iheight,
      toolbar: true,
      FurtherSetting: false,
      opacity: 1,
      originalOpacity: 1,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      ImageBlob: ImageBlob,
      startPositionOnTimeline: TickerPosition,
      player: false,
      transparency: false,
      textColor: null,
      stroke: 0,
      strokeColor: null,
      rotateAngle: 0,
      ColorsFound: [],
      showDiv: true,
    };

    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    setLayersData(LayersData.concat(newEntryLayerData));

    // let change = false;
    // const array = Array.from(slides)
    // for(let i = 0; i < array.length; i++)
    // {
    //     if(array[i].IsActive)
    //     {
    //         array[i].LayerData.push(newEntryLayerData)
    //         change = true;
    //     }
    // }

    // if(change)
    // {
    //   setTimeout(() => {
    //     setslides(array)
    //   }, 7000);

    // }
    setChangeCount(ChangeCount + 1);
    context.setIsLoading(false);
    seteditableObject({
      showPanel: true,
      editableItem: newEntryLayerData,
    });
  };

  const SvgContent = (url) => {
    let result = url.replace("/", "");

    return new Promise((resolve, reject) => {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Shapes/getSvgContent?p=" +
            result,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.svg != null && response.data.svg != "") {
            resolve(response.data.svg);
          } else {
            reject();
          }
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  };

  const ImageURLToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      var splittedURL = url.split("/");
      var imageName = splittedURL[splittedURL.length - 1];
      var extension = imageName.split(".")[1];

      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Images/ImageURLToBase64?url=" +
            url,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data != null && response.data != "") {
            var format = "data:image/jpeg;base64,";
            if (extension.toLowerCase() == "png") {
              format = "data:image/png;base64,";
            }
            var baseStr = format + response.data;

            resolve(baseStr);
          } else {
            reject();
          }
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  };

  const Delete = (ImageID) => {
    swal({
      title: "Do you really want to delete this Image?",
      buttons: true,
      dangerMode: true,
    }).then((value) => {
      if (value) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );

        fetch(
          authenticationData.ApiBaseURL +
            `/api/images/DeleteUserVideo?id=${ImageID}`,
          {
            method: "Delete",
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
          .then((response) => response.json())
          .then((res) => {
            if (res == true) {
              const array = Array.from(props.UploadedData);
              let changeArray = array.filter(function (value, index, arr) {
                if (value.id != ImageID) {
                  return value;
                }
              });
              props.setUploadData(changeArray);
              setImageData({ ...ImageData, UserData: changeArray });
              props.setIsDeleted(true);

              //props.getMyImages();
              swal("Excellent", "Image Has Been Deleted", "success");
            }
          })
          .catch((error) => {});
      }
    });
  };

  return (
    <>
      <div className="dragdivParent">
        <img
          sty
          src={props.url}
          alt=""
          className="imgtag"
          onClick={(e) => addImage(e, props.picurl)}
        />
        {props.isUserImage == "true" && (
          <div
            onClick={() => Delete(props.id)}
            className="userImgDelete"
            title="Delete this image"
          >
            <span
              className="material-icons"
              style={{ fontSize: "14px", lineHeight: "12px" }}
            >
              delete
            </span>
          </div>
        )}

        {Goto.menu !== "image" && (
          <div
            className="dragdiv"
            picurl={props.picurl}
            onClick={(e) => ImageConverter(e)}
            draggable="true"
            onDragStart={dragStart}
            onDrag={drag}
            onDragEnd={dragEnd}
          />
        )}
      </div>
    </>
  );
};
export default Photo;
